module.exports = __webpack_public_path__ + "img/details-bg.ccb1358f.png";